import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Product} from "../../models/product";
import {ProductService} from "../../services/product.service";

@Injectable()
export class ProductResolve implements Resolve<Product> {
    constructor(private productService: ProductService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Product> {
        return this.productService.getById(route.params.id);
    }
}
